import Typography from "../Typography";
import { TitleWithBorder as StyledTitleWithBorder } from "./styled";

export const TitleWithBorder = ({ variant = "h2", children: text }) => {
  return (
    <Typography as={StyledTitleWithBorder} variant={variant}>
      {text}
    </Typography>
  );
};
